module.exports = __webpack_public_path__ + "static/media/frustrert.d8fdfd51.m4a";